import React, {Component} from 'react';
import {connect} from 'react-redux';
import {actions} from 'react-redux-form';
import {Button, Col, Grid, Row} from 'react-bootstrap';
import StoreList from './store-list';
import PageTitle from '../common/page-title/index';
import InlineCKEditor from '../common/editor/inline-editor';
import {getOutlets, updateOutletReward} from '../../actions/outlet';
import {loadPageContent} from '../../actions/content';
import { tradeSiteEnabled } from '../../utils/toggles';
import IgniteUkLogo from '../../assets/img/ignite_logo_black.png';

import './store-summary.css';

class StoreSummary extends Component {
  onNextClicked = () => {
    const { storeRewards, dispatch } = this.props;

    const nonPendingOutlets = storeRewards.filter(outlet => !!outlet.customer_number);
    dispatch(actions.submit('deep.store_summary', updateOutletReward(nonPendingOutlets)));
  };
  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  constructor(props) {
    super(props);

    this.pageSlug = 'store-summary';
    this.stores = [];
  }

  componentWillMount() {
    const { dispatch, registration, isOnRegistrationPage } = this.props;

    if (tradeSiteEnabled() && isOnRegistrationPage) {
      dispatch(getOutlets(true));
    } else if (registration.pending && registration.internal) {
      dispatch({type: 'FINISH_REGISTRATION'});
      dispatch(getOutlets(false));
    } else {
      dispatch(getOutlets(registration.pending));
    }

    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  render() {
    const {
      registration, contents, stores, vouchers, fetching, fetched,
      isOnRegistrationPage
    } = this.props;
    const {
      pageSlug
    } = this;

    const shouldRenderNext = (registration.pending && !registration.internal)
      || (tradeSiteEnabled() && isOnRegistrationPage);

    return (
      <Grid bsClass="container-fluid" className={`stores ${registration.pending ? 'user-inner-container' : ''}`}>
        <Row>
          <Col lg={12} className={`stores-title-${registration.pending ? 'left' : 'center'}`}>
            {registration.pending && (
              <img src={IgniteUkLogo} alt="Ignite UK" />
            )}
            <PageTitle>
              Store summary
            </PageTitle>
          </Col>
        </Row>
        {
          !registration.pending && (
            <Row className="editable-content-wrapper">
              <Col lg={12}>
                <InlineCKEditor
                  contents={contents[`${pageSlug}_content_text`]}
                  identifier={`${pageSlug}_content_text`}
                  onContentSaved={this.handleContentSaved}
                />
              </Col>
            </Row>
          )}
        <Row>
          <Col lg={12}>
            <StoreList
              fetched={fetched}
              fetching={fetching}
              registration={registration}
              stores={stores}
              vouchers={vouchers}
            />
          </Col>
        </Row>
        {
          shouldRenderNext && (
            <Row>
              <Col lg={12}>
                <Col mdPush={8} md={4} className="stores-next-container">
                  <Button bsStyle="primary" className="red-ghost-btn pull-right" onClick={this.onNextClicked}>
                    Next
                  </Button>
                </Col>
              </Col>
            </Row>
          )}
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  stores: state.stores.stores,
  vouchers: state.stores.vouchers,
  fetched: state.stores.fetched,
  fetching: state.stores.fetching,
  registration: state.registration,
  storeRewards: state.deep.store_summary,
  contents: state.content.list
});

export default connect(mapStateToProps)(StoreSummary);



// WEBPACK FOOTER //
// ./src/components/store-summary/index.jsx